// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import SmileOutlined from '/app/node_modules/@ant-design/icons/es/icons/SmileOutlined';
import UserOutlined from '/app/node_modules/@ant-design/icons/es/icons/UserOutlined';
import FormOutlined from '/app/node_modules/@ant-design/icons/es/icons/FormOutlined';
import SnippetsOutlined from '/app/node_modules/@ant-design/icons/es/icons/SnippetsOutlined';
import SpotifyOutlined from '/app/node_modules/@ant-design/icons/es/icons/SpotifyOutlined';
import PictureOutlined from '/app/node_modules/@ant-design/icons/es/icons/PictureOutlined';
import BarsOutlined from '/app/node_modules/@ant-design/icons/es/icons/BarsOutlined';
import CrownOutlined from '/app/node_modules/@ant-design/icons/es/icons/CrownOutlined';
import HeatMapOutlined from '/app/node_modules/@ant-design/icons/es/icons/HeatMapOutlined';
import AppstoreAddOutlined from '/app/node_modules/@ant-design/icons/es/icons/AppstoreAddOutlined';
import NotificationOutlined from '/app/node_modules/@ant-design/icons/es/icons/NotificationOutlined';
import SettingOutlined from '/app/node_modules/@ant-design/icons/es/icons/SettingOutlined';
export default { SmileOutlined, UserOutlined, FormOutlined, SnippetsOutlined, SpotifyOutlined, PictureOutlined, BarsOutlined, CrownOutlined, HeatMapOutlined, AppstoreAddOutlined, NotificationOutlined, SettingOutlined };
